module.exports = __webpack_public_path__ + "static/KNS-ISO-27001-4118dce5ed780164d1c229b907745cd4.png";